import React from "react";
import styles from "./Card.module.scss";
import classNames from "classnames";
import { CheckComponent } from "./../..";
import _ from "lodash";
import { InlineLoader } from "./../Loaders";

export const Card = ({ children, className, style, hasHoverEffect, Component = "div", ...rest }) => {
    return <Component className={classNames(styles.base, className, { [styles['has-hover-effect']]: hasHoverEffect })} style={style} {...rest}>
        {children}
    </Component>
};

export const SelectableCard = ({ children, className, style, isSelected, selectedIconStyle, Component = "div", isDisabled, ...rest }) => {
    return <Card Component={Component} className={classNames(className, styles['selectable'], { [styles['selected']]: isSelected, [styles['disabled']]: isDisabled })} style={style} hasHoverEffect={!isDisabled} {...rest}>
        <CheckComponent className={styles['check']} style={selectedIconStyle} isSelected={isSelected}/>
        {children}
    </Card>
};

/**
 * type = large, small, simple
 */
export const CardHeader = ({ children, type = "large", className, style }) => {
    return <div className={classNames(styles.header, styles[type], className)} style={style}>
        {children}
    </div>
}

/**
 *
 * type = default, small
 */
export const CardContent = ({ children, className, style, type = "default" }) => {
    return <div className={classNames(styles.content, styles[type], className)} style={style}>
        {children}
    </div>
}

export const CardTitle = ({ children, className, style, SubHeader }) => {
    const isString = _.isString(children);
    return <div className={classNames(styles.title, className)} style={style} title={isString ? children : undefined}>
        {children}
        {SubHeader && <div className={styles['sub-header']}>{SubHeader}</div>}
    </div>
}

export const CardTableContent = ({ children, className, style, columns = "lg-3" }) => {
    return <div className={classNames(styles['table-content'], styles[columns], className)} style={style}>
        {children}
    </div>
}

export const CardTableItem = ({ children }) => {
    return <div className={styles['table-item']}>
        <div>
            {children}
        </div>
    </div>
}

export const LoadingCard = () => {
    return <Card>
        <CardContent>
            <InlineLoader/>
        </CardContent>
    </Card>
}